import React, { useState } from "react";
import { MoreHorizontal } from "react-feather";
import Card from "../Card/Card";
import Dropdown from "../../Dropdown/Dropdown";
import CustomInput from "../../CustomInput/CustomInput";
import "./BoardItem.css";
function Board(props) {
  console.log('propos board data:', props);
  const {
    board,
    addCard,
    removeBoard,
    removeCard,
    onDragEnd,
    onDragEnter,
    updateCard,
    myBoardId,
    members,
    handleUpdateTile,

  } = props;
  console.log(members);
  const [showDropdown, setShowDropdown] = useState(false);
  console.log("board in boardItem:", board);
  const [Changetittle, setChangetittle] = useState(false);
  const [editTitle, seteditTitle] = useState("");
  const changeTitle = () => {
    setChangetittle(true);
    seteditTitle(board.title)
  }
  console.log("edited title in boards .........", editTitle);

  const handleSubmit = () => {
    // board.title=editTitle
    // let board =board.title
    // updateCard(board)
    console.log("clicked :")
    setChangetittle(false);
    handleUpdateTile(board, editTitle)

    // console.log("updated data :",board)


  }
  return (
    <div className="board">
      <div className="board-inner"
        key={
          board?._id
        }
      >
        <div className="board-header">
          <div>
            {Changetittle ?

              <><form onSubmit={handleSubmit} >
                <input className="form-control" type="text" value={editTitle} onChange={(e) => seteditTitle(e.target.value)} /></form> </> : <p className="board-header-title" onClick={() => changeTitle()}>
                {board?.title}
                <span>{board?.cards?.length || 0}</span>
              </p>}
          </div>
          <div
            className="board-header-title-more"
            onClick={() => setShowDropdown(!showDropdown)}

          >
            <MoreHorizontal />
            {showDropdown && (
              <Dropdown>
                <p className="board-dropdown" onClick={() => removeBoard(board?._id)}>Delete Board</p>
              </Dropdown>
            )}
          </div>
        </div>

        <div className="board-cards custom-scroll">
          {board?.cards?.map((item) => (
            <Card
              key={item.id}
              card={item}
              boardId={board._id}
              boardMember={members}
              removeCard={removeCard}
              onDragEnter={onDragEnter}
              onDragEnd={onDragEnd}
              updateCard={updateCard}
            />
          ))}
          <CustomInput
            text="+ Add Card"
            placeholder="Enter Card Title"
            displayClass="board-add-card"
            editClass="board-add-card-edit"
            onSubmit={(value) => addCard(board._id, value)}
          />
        </div>
      </div>
    </div>
  );
}

export default Board;
